<div class="tw-flex tw-flex-col tw-w-full tw-h-full tw-overflow-y-auto tw-overflow-x-hidden">
    <user-followup class="tw-flex-1" [hideTitle]="false"></user-followup>
</div>
